import { useState } from "react";
import { Button, Spinner } from "reactstrap";
import { generatePrescriptionPdf } from "./PrescriptionAPI";
import { sendWhatsAppPrescription } from "../../../Components/utils/whatsapp";

const PrescriptionActions = ({
  prescription,
  branch,
  token,
  branchData,
  address,
  contactNo,
  size = "md",          // 👈 Added size prop (e.g. "sm", "md", "lg")
  className = "",       // 👈 Added custom className prop (e.g. "rounded-pill bg-white")
}) => {
  const [loading, setLoading] = useState(false);
  console.log(prescription);

  const handleWhatsApp = async () => {
    try {
      setLoading(true);

      // Safely check for the ID across different object formats
      const prescriptionId = prescription?._id?.$oid || prescription?._id || prescription?.id;

      if (!prescriptionId) {
        alert("Prescription not saved or ID is missing!");
        setLoading(false);
        return;
      }

      const res = await generatePrescriptionPdf(
        prescriptionId,
        branch,
        token,
        branchData,
        address
      );

      const pdfUrl = res?.data?.pdfUrl;

      if (!pdfUrl) {
        alert("Failed to generate prescription link");
        return;
      }

      sendWhatsAppPrescription({
        phone: contactNo,
        mrn: prescription.mrn,
        doctorName: prescription.doctorName,
 pdfUrl,
        branch
      });

    } catch (err) {
      console.error(err);
      alert("Failed to send WhatsApp prescription");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button 
      color="success" 
      outline // 👈 Makes it an outline button matching outline-secondary
      size={size} 
      className={`d-flex align-items-center gap-1 ${className}`} 
      onClick={handleWhatsApp} 
      disabled={loading}
    >
      {loading ? (
        <>
          <Spinner size="sm" className="me-1" />
          Sending...
        </>
      ) : (
        <>
          {/* Optional: Add an icon if you have lucide-react or similar package installed */}
          {/* <MessageCircle size={14} /> */}
          Send Prescription
        </>
      )}
    </Button>
  );
};

export default PrescriptionActions;